import { restClient } from '@/Core'

import type { UserCardValues } from '../Contracts/IUser'

/**
 * Часткова зміна співробітника: `PATCH /services/users/{uuid}?permissions=true`.
 *
 * Тіло — лише те, що змінюється (ролі, пароль, пароль Google Workspace): бек
 * перевіряє права на кожне поле тіла ще до десеріалізації (`SPEC-005` §3.1),
 * тож зайве поле в запиті могло б дати 403 там, де людина нічого чужого не
 * чіпала. Відповідь — оновлена картка з правами.
 */
export const PatchUserTask = async (uuid: string, json: Record<string, unknown>): Promise<UserCardValues> => {
    const response = await restClient.patch(`/services/users/${encodeURIComponent(uuid)}?permissions=true`, { json })

    // Ядровий клієнт оголошений як ky-відповідь, а віддає розібраний JSON
    return (response ?? {}) as unknown as UserCardValues
}
